//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/SIM.PostConfigurator.js";
import "../no/Builder.js";
let d=[[[0,"ExpirationDate",1,0],[0,"SMKSLicensecheck",1,0]],[[["encryptFilename"],"SetEncryptPostprocessorFiles",{},1,0],[["encryptFilesCount"],"GetEncryptPostprocessorFiles",{R_:{encryptFiles:""}},0,0],[["soldToIDs"],"SetSoldToIds",{},1,0],[[],"GetSoldToIds",{R_:{soldToIDs:''}},0,0]],[]];
SPLM.SIM.PostConfigurator.EncryptPostprocessorFilesBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SIM.PostConfigurator.EncryptPostprocessorFilesBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;